import { Directive, Input, OnInit } from '@angular/core';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsDataChangeService } from '@icms/core/data/change/icms-data-change.service';
import { LocalPage } from '../local/local-page';

@Directive()
export class PageViewAbstract extends UiComponent implements OnInit {
    @Input()
    model?: LocalPage<IPageDataV3>;

    constructor(protected iCmsDataChangeService: ICmsDataChangeService) {
        super();
    }

    override ngOnInit() {
        this.subscriptions.add(
            this.iCmsDataChangeService.afterChange$.subscribe(event => {
                const parentPath = ['data', 'parent'];
                if (event.model === this.model && this.iCmsDataChangeService.filterByData(event, this.model.type, [parentPath])) {
                    this.detectChanges();
                }
            })
        );
        super.ngOnInit();
    }
}
